// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var OAuthClientsController = function ($scope, $location, OAuthClient, gettext, gettextCatalog) {

    $scope.clients = OAuthClient.query();
    $scope.newClient = new OAuthClient();
    $scope.newClient.ClientType = 'Confidential';

    $scope.gotoClientDetails = function (clientId) {
        $location.path(`/settings/oauth-clients/${clientId}`);
    }

    $scope.createClient = function () {
        $scope.newClient.$save({}, function (data) {
            if (data.ClientType === 'Confidential') {
                $scope.gotoClientDetails(data.Id)
            } else {
                $scope.clients.push(data);
                $scope.newClient = new OAuthClient();
                $scope.newClient.ClientType = 'Confidential';
            }
        });
    };

    $scope.deleteClient = function (clientId, index) {
        $scope.yesCancel(gettextCatalog.getString(gettext("Delete OAuth Client")), gettextCatalog.getString(gettext("Are you sure?")), function () {
            OAuthClient.remove({clientId: clientId}, function () {
                $scope.clients.remove(index);
            });
        });
    };

    $scope.getClientTypeName = function (type) {
        const clientType = {
            'OIDC': 'OpenID Connect Client'
        };
        return clientType[type] ? clientType[type] : type;
    };
};

OAuthClientsController.$inject = ['$scope', '$location', 'OAuthClient', 'gettext', 'gettextCatalog'];